import { useSettings } from "../contexts/SettingsContext";

/**
 * Announcement marquee — infinite right→left scroll, 1-second gap between
 * each loop cycle. Admin controls the list of items (one row per item) from
 * /admin/homepage → Marquee Items. When none are configured, the default
 * two-item business announcement is shown.
 */
const SCROLL_MS = 18000;   // time to scroll once across viewport (iter35: slightly faster)
const PAUSE_MS = 1000;     // 1-second gap before repeating
const TOTAL_MS = SCROLL_MS + PAUSE_MS;
const SCROLL_PCT = ((SCROLL_MS / TOTAL_MS) * 100).toFixed(2);

export default function AnnouncementBanner() {
  const { formatThreshold, settings } = useSettings();
  const min = settings?.min_order_amount || 200;
  const defaults = [
    `FREE DELIVERY ON ORDERS ABOVE ${formatThreshold()}/-!!!`,
    `MINIMUM ORDERING AMOUNT IS ₹${Number(min).toFixed(0)}/-`,
  ];
  // null/undefined → never configured → use bundled defaults.
  // Empty array `[]` → admin explicitly cleared the marquee → render nothing.
  const saved = settings?.marquee_items;
  const items = Array.isArray(saved) ? saved : defaults;
  if (items.length === 0) return null;
  const text = items.join("   •   ");

  return (
    <div
      className="w-full bg-brand-chili text-brand-cream overflow-hidden select-none"
      role="status"
      aria-label="Promotional announcement"
      data-testid="announcement-banner"
    >
      <style>{`
        @keyframes sdf-banner-scroll {
          0%   { transform: translate3d(100vw, 0, 0); }
          ${SCROLL_PCT}% { transform: translate3d(-100%, 0, 0); }
          100% { transform: translate3d(-100%, 0, 0); }
        }
        .sdf-banner-text {
          animation: sdf-banner-scroll ${TOTAL_MS}ms linear infinite;
        }
      `}</style>
      <div className="h-[46px] sm:h-[50px] lg:h-[54px] flex items-center">
        <span
          className="sdf-banner-text inline-block whitespace-nowrap font-semibold text-sm sm:text-[15px] tracking-[0.18em] uppercase will-change-transform"
          data-testid="announcement-text"
        >
          {text}
        </span>
      </div>
    </div>
  );
}
